import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { IconPaths } from '../../../../../../../../_metronic/helpers/enumsUI'
import { RowActions } from '../../../../../../../components/Table/TableCells'
import { ModeloVersaoLinha } from '../../../../core/_models'
import { rotaDetalheModelo } from '../../core/rotas'

type Props = {
  versao: ModeloVersaoLinha
}

/** Ação da versão do modelo: a lupa abre o detalhe. */
export const ModeloPlataformaActionsCell: FC<Props> = ({ versao }) => {
  const navigate = useNavigate()

  return (
    <RowActions
      itemName={`versão ${versao.versao} do modelo`}
      primaryAction={{
        label: 'Ver detalhe',
        onClick: () => navigate(rotaDetalheModelo(versao.id)),
        icon: IconPaths.Search,
      }}
    />
  )
}
